<template>
  <div class="container">
    <div class="login mt-5">
      <div class="card">
        <div class="card-header">Login</div>
        <div class="card-body">
          <form @submit.prevent="login" method="post" action="#">
            <div class="form-group">
              <label for="name">Nombre de usuario</label>
              <input
                type="text"
                name="username"
                autocomplete="username"
                class="form-control"
                :class="{ 'is-invalid': errors.name }"
                id="name"
                v-model="details.name"
                placeholder="Nombre de usuario..."
                required
              />
              <div class="invalid-feedback" v-if="errors.name">
                {{ errors.name[0] }}
              </div>
            </div>
            <div class="form-group">
              <label for="password">Contraseña</label>
              <input
                type="password"
                name="password"
                autocomplete="current-password"
                class="form-control"
                :class="{ 'is-invalid': errors.password }"
                id="password"
                v-model="details.password"
                placeholder="Contraseña..."
                required
              />
              <div class="invalid-feedback" v-if="errors.password">
                {{ errors.password[0] }}
              </div>
            </div>
            <div class="alert alert-danger" role="alert" v-if="error">
              {{ typeof error === 'string' ? error : (error.message || error.error || error) }}
            </div>
            <button type="submit" class="btn btn-primary">
              Ingresar
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { getDefaultRouteForUser, getUserFromToken } from "../../router";

export default {
  name: "Home",

  data: function() {
    return {
      details: {
        name: localStorage.getItem("last_username") || null,
        password: null
      }
    };
  },

  computed: {
    ...mapGetters(["errors", "error"])
  },

  mounted() {
    this.$store.commit("setErrors", {});
    this.$store.commit("setError", null);
  },

  methods: {
    ...mapActions("auth", ["sendLoginRequest"]),

    login: function() {
      if (this.details.name) {
        localStorage.setItem("last_username", this.details.name);
      }
      this.sendLoginRequest(this.details)
        .then(() => {
          const user = this.$store.getters["auth/user"] || getUserFromToken();
          if (user) {
            let integrador = localStorage.getItem("integrador");
            if (!integrador && user.integradores && user.integradores.length > 0) {
              integrador = user.integradores[0].id_integrador || user.integradores[0].id;
              localStorage.setItem("integrador", integrador);
              this.$store.commit("integrador/setIntegrador", integrador);
            }
            const target = getDefaultRouteForUser(user);
            this.$router.push(target).catch(() => {});
          }
        })
        .catch(() => {});
    }
  }
};
</script>

